namespace GeniuzPOS.Lookups {
    export namespace VwApprovalGroupService {
        export const baseUrl = 'Lookups/VwApprovalGroup';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwApprovalGroupRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Lookups/VwApprovalGroup/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>VwApprovalGroupService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
